import {createSlice} from '@reduxjs/toolkit';
import {firestore} from "../../config/firebaseConfig";
import { toast } from 'react-toastify';
import {groupShipping} from "../../utils/inventory";

const initialState = {
    isLoading: false,
    error: false,
    isSucces: false,
    arrivals: [],
};

const slice = createSlice({
    name: 'arrivals',
    initialState,
    reducers: {
        // START LOADING
        startLoading(state) {
            state.isSucces = false;
            state.isLoading = true;
            state.error = false;
        },

        // HAS ERROR
        hasError(state, action) {
            state.isLoading = false;
            state.isSucces = false;
            state.error = action.payload;
            console.log(action.payload);
            toast.error("Error");
        },


        createSuccess(state){
            state.isLoading = false;
            state.isSucces = true;
            state.error = false;
            toast.success("Success");
        }


    }
});


export default slice.reducer;

//------------------------------------------------------------------
export function createArrivals(containers, callback=null) {

    return async (dispatch) => {
        dispatch(slice.actions.startLoading());

        try {

            let shippingsDetails = [];
            console.log(containers);

            await Promise.all(containers.map(async(id)=>{
                var responses = await firestore.collection('shipping_orders').doc(id).collection('Shippings_c').get();
                responses.docs.forEach((doc)=>{
                    shippingsDetails.push({id: doc.id, ...doc.data()});
                });
            }));

            console.log(shippingsDetails);

            
            let list =  groupShipping(shippingsDetails);

            const snap = await firestore.collection('arrivals').add({
                createdAt: new Date()
            });

            const subRef = snap.collection('list');

            let groups = [];
            let cursor = 400;
            let splitIndex = 0;

            while (list.length >= splitIndex) {
                if (list.length - cursor >= 0) {
                    groups.push(list.slice(splitIndex, cursor))
                } else {
                    let overIndex = cursor - list.length;
                    let restIndex = 400 - overIndex;
                    groups.push(list.slice(splitIndex, splitIndex + restIndex))
                    break;
                }

                splitIndex += 400;
                cursor += 400;
            }

            await Promise.all(groups.map(async (group) =>{
                const batch = firestore.batch();

                await Promise.all(group.map(async one=>{
                    const itemDc = await firestore.collection('items').doc(one.ProductId).get();
                    const cat = itemDc.exists ? itemDc.data()?.Categorie || null : null
                    console.log(one.ProductId, itemDc.data());
                    console.log(one.ProductId, itemDc.exists);
                    const data = {...one, Categorie: cat}
                    const doc = subRef.doc();
                    console.log(data);
                    console.log("batch");
                    batch.set(doc, data);
                }));
                console.log("End");
               await batch.commit();
            }))

            dispatch(slice.actions.createSuccess());
            

            if(callback) callback();
        } catch (error) {
            console.error(error);
            dispatch(slice.actions.hasError(error));
        }
    }
}
